import { isFunction } from 'lodash'

export function tryToLoadScript(
  url,
  callback?,
  attrs: Record<string, string> = {},
  dataset: Record<string, string> = {}
) {
  if (!url) {
    return
  }
  const isLoaded = !!document.querySelector("script[src*='" + url + "']")
  if (isLoaded) {
    if (isFunction(callback)) callback()
    return
  }
  const header = document.getElementsByTagName('head')[0]
  const script = document.createElement('script')
  script.setAttribute('src', url)
  script.setAttribute('type', attrs?.type || 'text/javascript')
  script.setAttribute('charset', attrs?.charset || 'utf-8')
  Object.entries(attrs).forEach(([key, value]) => {
    script.setAttribute(key, value)
  })
  Object.entries(dataset).forEach(([key, value]) => {
    script.dataset[key] = value
  })
  script.onload = () => {
    if (isFunction(callback)) callback()
  }

  header.appendChild(script)

  return script
}
